module.exports = __webpack_public_path__ + "static/assets/344dc88f4d5187f0d86f2f13c9ef1727.mp3";